<template>
  <div>
    <el-form :model="searchForm" inline  size="small">
      <el-form-item label="会议日期">
        <el-date-picker
          v-model="searchForm.time"
          type="daterange"
          clearable
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </el-form-item>
      <el-form-item label="参会人">
        <el-input v-model="searchForm.user_name" clearable></el-input>
      </el-form-item>
       <el-form-item
          label="部门">
          <el-select
            v-model="searchForm.department_id"
            clearable
            placeholder="请选择部门">
            <el-option
              v-for="(item, index) in departmentList"
              :key="index"
              :label="item.department"
              :value="item.id"/>
          </el-select>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="searchList()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading"  :span-method="objectSpanMethod" highlight-current-row
    :data="dataList" :header-cell-style="{background:'#409eff',padding:'8px 0',color:'#fff'}" size="small" border style="margin-top: 20px">
      <el-table-column label="编号" prop="number" align="center"/>
      <el-table-column label="会议日期" prop="date_time" align="center"/>
      <el-table-column label="部门" prop="department" align="center"/>
      <el-table-column label="负责人" prop="name" align="center" />
      <el-table-column label="会议类型" prop="type_name" align="center" />
      <el-table-column label="会议次数" prop="meeting_count_all" align="center"/>
      <el-table-column label="实际会议次数" prop="meeting_count_normal" align="center"/>
      <el-table-column prop="score" width="200" label="会议评分" align="center">
      <template slot-scope="scope">
        {{scope.row.avg_score}}
      </template>
    </el-table-column>
    </el-table>
    <div style="margin-top: 10px; text-align:center">
      <el-pagination
        :page-sizes="[10,20,30,50,100,200,500,1000]"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>
<script>
import { departmentRole } from '@/api/static'
import { getAllSecretary } from '@/api/secretary'

export default {
  name: 'TabPerson',
  data() {
    return {
      searchForm: {
        time: [],
        user_name: '',
        department_id: []
      },
      loading: false,
      dataList: [],
      page: 1,
      pageSize: 50,
      total: 0,
      today: '',
      departmentList: [],
      // 表格合并的方法，部门和日期合并上下列
      dateTimeArr: [], // 第一列进行合并操作时存放的数组变量
      deteTimePos: 0, // 上面的数组的下标值
      departmentArr: [], // 第二列进行合并操作时存放的数组变量
      departmentPos: 0, // 上面的数组的下标值
      nameArr: [], // 第二列进行合并操作时存放的数组变量
      namePos: 0 // 上面的数组的下标值
    }
  },
  created() {
    const now = new Date()
    now.setTime(now.getTime())
    const Y = now.getFullYear()
    const M = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
    const D = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
    const today = Y + '-' + M + '-' + D
    this.searchForm.time = [today, today]
    this.today = today
    this.getDepartment()
  },
  methods: {
    // 表格合并列 部门和日期列相同的合并
    merageInit() {
      this.dateTimeArr = []
      this.deteTimePos = 0
      this.departmentArr = []
      this.departmentPos = 0
      this.nameArr = []
      this.namePos = 0
    },
    merage() {
      this.merageInit()
      for (let i = 0; i < this.dataList.length; i += 1) {
        if (i === 0) {
          // 第一行必须存在
          this.dateTimeArr.push(1)
          this.deteTimePos = 0
          this.departmentArr.push(1)
          this.departmentPos = 0
          this.nameArr.push(1)
          this.namePos = 0
        } else {
          // 判断当前元素与上一个元素是否相同,eg：this.typeNamePos 是 this.typeNameArr序号
          // 第一列
          // eslint-disable-next-line no-lonely-if
          if (this.dataList[i].date_time === this.dataList[i - 1].date_time) {
            this.dateTimeArr[this.deteTimePos] += 1
            this.dateTimeArr.push(0)
          } else {
            this.dateTimeArr.push(1)
            this.deteTimePos = i
          }
          // 第二列
          if (this.dataList[i].department === this.dataList[i - 1].department && this.dataList[i].date_time ===
              this.dataList[i - 1].date_time) {
            this.departmentArr[this.departmentPos] += 1
            this.departmentArr.push(0)
          } else {
            this.departmentArr.push(1)
            this.departmentPos = i
          }
          // 第三列
          if (this.dataList[i].name === this.dataList[i - 1].name) {
            this.nameArr[this.namePos] += 1
            this.nameArr.push(0)
          } else {
            this.nameArr.push(1)
            this.namePos = i
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        // 第一列的合并方法
        const row1 = this.dateTimeArr[rowIndex]
        const col1 = row1 > 0 ? 1 : 0 // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row1,
          colspan: col1
        }
      } else if (columnIndex === 2) {
        // 第二列的合并方法
        const row2 = this.departmentArr[rowIndex]
        const col2 = row2 > 0 ? 1 : 0 // 如果被合并了row = 0; 则他这个列需要取消
        // 合并总计
        // 正常相同的合并
        return {
          rowspan: row2,
          colspan: col2
        }
      } else if (columnIndex === 3) {
        // 第四列的合并方法
        const row3 = this.nameArr[rowIndex]
        const col3 = row3 > 0 ? 1 : 0 // 如果被合并了row = 0; 则他这个列需要取消
        return {
          rowspan: row3,
          colspan: col3
        }
      }
    },
    searchList() {
      this.page = 1
      this.getList()
    },
    getList() {
      const params = {
        start_time: this.searchForm.time ? this.searchForm.time[0] : null,
        end_time: this.searchForm.time ? this.searchForm.time[1] : null,
        user_name: this.searchForm.user_name,
        department_id: this.searchForm.department_id || null,
        page: this.page,
        pageSize: this.pageSize
      }

      this.loading = true
      departmentRole(params).then(res => {
        this.loading = false
        if (res.code === 'success') {
          this.dataList = res.data.data
          this.total = res.data.total
          this.merage()
        } else {
          this.total = 0
          this.dataList = []
        }
      }).catch(() => {
        this.loading = false
        this.total = 0
        this.dataList = []
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    getDepartment() {
      const params = {
        is_available: 1,
        page: 1,
        page_size: 10000
      }
      getAllSecretary(params).then((res) => {
        console.log(res)
        if (res.code === 'success' && res.data && res.data.secretary) {
          this.departmentList = res.data.secretary
        } else {
          this.departmentList = []
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .forDetail{
    color:#6d9eeb;
    cursor: pointer;
    &:hover{
      text-decoration: underline;
      color: #4183ea;
    }
  }
</style>
